import loginVideo from "../assets/login.mp4";
import LoginForm from "../components/LoginForm";

export default function Login(): React.ReactElement {
    return (
        <div className="flex flex-col lg:flex-row min-h-screen overflow-hidden">
            <div className="w-full lg:w-[1090px]">
                <video
                    src={loginVideo}
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="w-full h-full xl:h-screen object-cover"
                />

            </div>

            {/* Right Side - Login Form */}
            <div className="w-[80%] xl:w-1/2 flex items-center justify-center p-6">
                <LoginForm />
            </div>
        </div>
    );
};